import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";

interface Metric {
  label: string;
  value: string;
}

interface Props {
  metric: Metric;
}

const MetricsCard = ({ metric: { value, label } }: Props) => (
  <Card sx={{ flexGrow: 1 }}>
    <CardContent sx={{ textAlign: "center" }}>
      <Typography variant="subtitle1" gutterBottom>
        {label}
      </Typography>
      <Typography variant="h5">{value}</Typography>
    </CardContent>
  </Card>
);

export default MetricsCard;
